import { render, staticRenderFns } from "./LgFinderTipoDocumento.vue?vue&type=template&id=a9ba49ea"
import script from "./LgFinderTipoDocumento.vue?vue&type=script&lang=js"
export * from "./LgFinderTipoDocumento.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports